/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Modal_Maybe_LaterInputs */

const en_upgrade_modal_maybe_later = /** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maybe later`)
};

const es_upgrade_modal_maybe_later = /** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quizás más tarde`)
};

const fr_upgrade_modal_maybe_later = /** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peut-être plus tard`)
};

const de_upgrade_modal_maybe_later = /** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vielleicht später`)
};

const id_upgrade_modal_maybe_later = /** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mungkin nanti`)
};

/** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */
const ja_upgrade_modal_maybe_later = en_upgrade_modal_maybe_later;

/** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */
const zh_upgrade_modal_maybe_later = en_upgrade_modal_maybe_later;

/** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */
const ar_upgrade_modal_maybe_later = en_upgrade_modal_maybe_later;

/** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */
const it_upgrade_modal_maybe_later = en_upgrade_modal_maybe_later;

/** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */
const ru_upgrade_modal_maybe_later = en_upgrade_modal_maybe_later;

/** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */
const pt_upgrade_modal_maybe_later = en_upgrade_modal_maybe_later;

/** @type {(inputs: Upgrade_Modal_Maybe_LaterInputs) => LocalizedString} */
const ko_upgrade_modal_maybe_later = en_upgrade_modal_maybe_later;

/**
* | output |
* | --- |
* | "Maybe later" |
*
* @param {Upgrade_Modal_Maybe_LaterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_modal_maybe_later = /** @type {((inputs?: Upgrade_Modal_Maybe_LaterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Modal_Maybe_LaterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_modal_maybe_later(inputs)
	if (locale === "es") return es_upgrade_modal_maybe_later(inputs)
	if (locale === "fr") return fr_upgrade_modal_maybe_later(inputs)
	if (locale === "de") return de_upgrade_modal_maybe_later(inputs)
	if (locale === "ja") return ja_upgrade_modal_maybe_later(inputs)
	if (locale === "zh") return zh_upgrade_modal_maybe_later(inputs)
	if (locale === "ar") return ar_upgrade_modal_maybe_later(inputs)
	if (locale === "id") return id_upgrade_modal_maybe_later(inputs)
	if (locale === "it") return it_upgrade_modal_maybe_later(inputs)
	if (locale === "ru") return ru_upgrade_modal_maybe_later(inputs)
	if (locale === "pt") return pt_upgrade_modal_maybe_later(inputs)
	return ko_upgrade_modal_maybe_later(inputs)
});